import React from 'react';

const PassoverMenuDisclaimer = ({ hideTitle, hidePriceMinimumNotice, hideSederNotice, hideOrderInfoDisclaimer }) => {
    return (
        <section id="passover-menu-title-section">
        { (!hideTitle) ?
            <div>
                <h3 className="sub-title">View our menu order form below to place your order!</h3>
            </div>
        : undefined }
        <div id="passover-menu-disclaimer-section">
            <p className="passover-disclaimer-text">
                MUST PLACE ORDERS NO LATER THAN 1:00 PM friday, Sept 4<sup>TH</sup>, 2026
                <span className="passover-disclaimer-divider"></span>
            </p>
            <p className="passover-disclaimer-text">
                ORDERS ARE AVAILABLE FOR PICK-UP friday, Sept 11<sup>th</sup>, BETWEEN 1:00 P.M. & 4:00 P.M
                <span className="passover-disclaimer-divider"></span>
            </p>
            { (!hidePriceMinimumNotice) ?
                <p className="passover-disclaimer-text">
                    MINIMUM ORDERS $100.00
                    <span className="passover-disclaimer-divider"></span>
                </p>
                 : undefined
            }
            { (!hideSederNotice) ?
                <p className="passover-disclaimer-text">
                    PRIVATE SEDERS AVAILABLE
                    <span className="passover-disclaimer-divider"></span>
                </p>
                : undefined
            }
            { !hideOrderInfoDisclaimer && (
                <div className='order-info-disclaimer'>
                    <p>If you are adding to an existing order, please use the same email address as your original order.</p>
                    <p>If you wish to change items in an existing order, please contact the office at <span className='no-wrap'>516-678-6161</span> or <span className='no-wrap'>party@kombertcaterers.com</span></p>
                </div>
            )}
        </div>
    </section>
    )
}

export default PassoverMenuDisclaimer;
